import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AdminApiService, ClientConfigResponse } from '../services/admin-api.service';

@Component({
  selector: 'app-client-edit',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  template: `
    <div class="page" *ngIf="config">
      <div class="page-header">
        <div>
          <a routerLink="/admin" class="back-link">← Volver a clientes</a>
          <h2>{{ config.code }} — {{ config.client.name }}</h2>
        </div>
        <button class="btn btn-primary" (click)="save()" [disabled]="saving">
          {{ saving ? 'Guardando...' : '💾 Guardar' }}
        </button>
      </div>

      <div class="message success" *ngIf="message">{{ message }}</div>
      <div class="message error" *ngIf="error">{{ error }}</div>

      <!-- Client Info -->
      <section class="card">
        <h3>🏢 Información del Cliente</h3>
        <div class="form-row">
          <div class="form-group">
            <label>Nombre</label>
            <input [(ngModel)]="flat.client_name" class="input" />
          </div>
          <div class="form-group">
            <label>Subtítulo</label>
            <input [(ngModel)]="flat.client_subtitle" class="input" />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label>Logo</label>
            <div class="file-upload">
              <img *ngIf="config.client.logo" [src]="config.client.logo" class="preview-img" alt="Logo" />
              <label class="btn btn-sm upload-btn">
                📤 Subir logo
                <input type="file" accept="image/*" (change)="uploadLogo($event)" hidden />
              </label>
            </div>
          </div>
          <div class="form-group">
            <label>Favicon</label>
            <div class="file-upload">
              <img *ngIf="config.client.favicon" [src]="config.client.favicon" class="preview-img" alt="Favicon" />
              <label class="btn btn-sm upload-btn">
                📤 Subir favicon
                <input type="file" accept="image/*" (change)="uploadFavicon($event)" hidden />
              </label>
            </div>
          </div>
        </div>
      </section>

      <!-- Branding -->
      <section class="card">
        <h3>🎨 Branding (Colores)</h3>
        <div class="colors-grid">
          <div class="color-field" *ngFor="let c of colorFields">
            <label>{{ c.label }}</label>
            <div class="color-input-row">
              <input type="color" [ngModel]="flat[c.key]" (ngModelChange)="flat[c.key] = $event" class="color-picker" />
              <input [ngModel]="flat[c.key]" (ngModelChange)="flat[c.key] = $event" class="input color-text" />
            </div>
          </div>
        </div>
        <div class="preview-bar" [style.background]="flat.branding_background_color">
          <button [style.background]="flat.branding_primary_color" [style.color]="'#fff'" class="preview-btn">Primary</button>
          <button [style.background]="flat.branding_accent_color" [style.color]="'#fff'" class="preview-btn">Accent</button>
          <span class="preview-card"
            [style.background]="flat.branding_card_background"
            [style.color]="flat.branding_text_muted"
            [style.border-color]="flat.branding_border_color">Card</span>
        </div>
      </section>

      <!-- Kiosk Settings -->
      <section class="card">
        <h3>🖥️ Configuración del Kiosko</h3>
        <div class="form-row">
          <div class="form-group">
            <label>Contraseña de salida</label>
            <input [(ngModel)]="flat.kiosk_exit_password" class="input mono" />
          </div>
          <div class="form-group">
            <label>Timeout inactividad (seg)</label>
            <input type="number" [(ngModel)]="flat.kiosk_inactivity_timeout_seconds" class="input" />
          </div>
        </div>
        <div class="checkbox-row">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="flat.kiosk_show_best_scores" />
            Mostrar mejores puntajes
          </label>
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="flat.is_active" />
            Cliente activo
          </label>
        </div>
      </section>

      <!-- Games Config -->
      <section class="card">
        <h3>🎮 Juegos</h3>
        <div class="games-list">
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_memory_enabled" /> 🧠 Memory Match</label>
            <div class="game-setting" *ngIf="flat.game_memory_enabled">
              <label>Pares</label>
              <input type="number" [(ngModel)]="flat.game_memory_pairs" class="input input-sm" />
            </div>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_puzzle_enabled" /> 🧩 Slide Puzzle</label>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_reaction_enabled" /> ⚡ Reaction Time</label>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_simon_enabled" /> 🎵 Simon Says</label>
            <div class="game-setting" *ngIf="flat.game_simon_enabled">
              <label>Colores</label>
              <input type="number" [(ngModel)]="flat.game_simon_colors" class="input input-sm" />
              <label>Velocidad (ms)</label>
              <input type="number" [(ngModel)]="flat.game_simon_speed_ms" class="input input-sm" />
            </div>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_whack_enabled" /> 🎯 Atrapa el Logo</label>
            <div class="game-setting" *ngIf="flat.game_whack_enabled">
              <label>Duración (seg)</label>
              <input type="number" [(ngModel)]="flat.game_whack_duration_seconds" class="input input-sm" />
            </div>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_speedtap_enabled" /> 👆 Speed Tap</label>
            <div class="game-setting" *ngIf="flat.game_speedtap_enabled">
              <label>Duración (seg)</label>
              <input type="number" [(ngModel)]="flat.game_speedtap_duration_seconds" class="input input-sm" />
            </div>
          </div>
          <div class="game-row">
            <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.game_balloonpop_enabled" /> 🎈 Balloon Pop</label>
            <div class="game-setting" *ngIf="flat.game_balloonpop_enabled">
              <label>Duración (seg)</label>
              <input type="number" [(ngModel)]="flat.game_balloonpop_duration_seconds" class="input input-sm" />
            </div>
          </div>
        </div>
      </section>

      <!-- Records Config -->
      <section class="card">
        <h3>📋 Records</h3>
        <div class="checkbox-row">
          <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.records_enabled" /> Records habilitados</label>
          <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.records_require_rut" /> Requerir RUT</label>
          <label class="checkbox-label"><input type="checkbox" [(ngModel)]="flat.records_require_name" /> Requerir nombre</label>
        </div>
        <div class="form-group" style="max-width: 200px; margin-top: 12px;">
          <label>Máximo entradas por juego</label>
          <input type="number" [(ngModel)]="flat.records_max_entries_per_game" class="input" />
        </div>
      </section>
    </div>

    <div class="loading" *ngIf="!config && !error">Cargando configuración...</div>
  `,
  styles: [`
    .page { max-width: 900px; }

    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 24px;
    }

    .back-link {
      font-size: 13px;
      color: #4338ca;
      text-decoration: none;
      margin-bottom: 4px;
      display: inline-block;
    }

    .back-link:hover { text-decoration: underline; }

    .page-header h2 {
      font-size: 24px;
      font-weight: 700;
      color: #1e293b;
      margin: 4px 0 0;
    }

    .card {
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 24px;
      margin-bottom: 20px;
    }

    .card h3 {
      font-size: 16px;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 16px;
    }

    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      margin-bottom: 12px;
    }

    .form-group { margin-bottom: 8px; }

    .form-group label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
      margin-bottom: 6px;
    }

    .input {
      width: 100%;
      padding: 9px 12px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      font-size: 14px;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.15s;
    }

    .input:focus { border-color: #4338ca; box-shadow: 0 0 0 3px rgba(67,56,202,0.1); }

    .input-sm { width: 80px; display: inline-block; }

    .mono { font-family: monospace; }

    .colors-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      margin-bottom: 16px;
    }

    .color-field label {
      font-size: 12px;
      color: #64748b;
      margin-bottom: 4px;
      display: block;
    }

    .color-input-row {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .color-picker {
      width: 36px;
      height: 36px;
      border: 1px solid #e2e8f0;
      border-radius: 6px;
      cursor: pointer;
      padding: 2px;
    }

    .color-text {
      width: 100px;
      font-family: monospace;
      font-size: 13px;
    }

    .preview-bar {
      padding: 16px;
      border-radius: 8px;
      display: flex;
      gap: 12px;
      align-items: center;
      border: 1px solid #e2e8f0;
    }

    .preview-btn {
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;
      cursor: default;
    }

    .preview-card {
      padding: 8px 16px;
      border-radius: 6px;
      font-size: 13px;
      border: 1px solid;
    }

    .checkbox-row {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
    }

    .checkbox-label {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #334155;
      cursor: pointer;
    }

    .checkbox-label input[type="checkbox"] {
      width: 16px;
      height: 16px;
      accent-color: #4338ca;
    }

    .games-list { display: flex; flex-direction: column; gap: 12px; }

    .game-row {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 10px 14px;
      background: #f8fafc;
      border-radius: 8px;
      flex-wrap: wrap;
    }

    .game-setting {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #64748b;
    }

    .game-setting label { font-size: 12px; color: #94a3b8; }

    .file-upload {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .preview-img {
      height: 44px;
      max-width: 120px;
      object-fit: contain;
      background: #f1f5f9;
      border-radius: 6px;
      padding: 4px;
    }

    .upload-btn { cursor: pointer; }

    .btn {
      padding: 8px 16px;
      border-radius: 8px;
      border: 1px solid #e2e8f0;
      background: #fff;
      color: #334155;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      text-decoration: none;
      transition: all 0.15s;
    }

    .btn:hover { background: #f1f5f9; }
    .btn-sm { padding: 6px 12px; font-size: 12px; }

    .btn-primary {
      background: #4338ca;
      color: #fff;
      border-color: #4338ca;
    }

    .btn-primary:hover { background: #3730a3; }
    .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

    .message {
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .message.success { background: #dcfce7; color: #166534; border: 1px solid #bbf7d0; }
    .message.error { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }

    .loading { text-align: center; padding: 60px; color: #94a3b8; font-size: 16px; }
  `]
})
export class ClientEditComponent implements OnInit {
  config: ClientConfigResponse | null = null;
  flat: any = {};
  saving = false;
  message = '';
  error = '';
  clientCode = '';

  colorFields = [
    { key: 'branding_primary_color', label: 'Primary' },
    { key: 'branding_primary_hover', label: 'Primary Hover' },
    { key: 'branding_primary_dark', label: 'Primary Dark' },
    { key: 'branding_primary_light', label: 'Primary Light' },
    { key: 'branding_accent_color', label: 'Accent' },
    { key: 'branding_accent_light', label: 'Accent Light' },
    { key: 'branding_background_color', label: 'Background' },
    { key: 'branding_card_background', label: 'Card Background' },
    { key: 'branding_text_primary', label: 'Text Primary' },
    { key: 'branding_text_muted', label: 'Text Muted' },
    { key: 'branding_border_color', label: 'Border' },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: AdminApiService,
  ) {}

  ngOnInit() {
    this.clientCode = this.route.snapshot.paramMap.get('code') || '';
    if (!this.clientCode) {
      this.router.navigate(['/admin']);
      return;
    }
    this.loadConfig();
  }

  loadConfig() {
    this.api.getClient(this.clientCode).subscribe({
      next: (data) => {
        this.config = data;
        this.flat = this.configToFlat(data);
      },
      error: () => {
        this.error = `Cliente "${this.clientCode}" no encontrado`;
      }
    });
  }

  configToFlat(c: ClientConfigResponse): any {
    return {
      is_active: c.isActive,
      client_name: c.client.name,
      client_subtitle: c.client.subtitle,
      branding_primary_color: c.branding.primaryColor,
      branding_primary_hover: c.branding.primaryHover,
      branding_primary_dark: c.branding.primaryDark,
      branding_primary_light: c.branding.primaryLight,
      branding_accent_color: c.branding.accentColor,
      branding_accent_light: c.branding.accentLight,
      branding_background_color: c.branding.backgroundColor,
      branding_card_background: c.branding.cardBackground,
      branding_text_primary: c.branding.textPrimary,
      branding_text_muted: c.branding.textMuted,
      branding_border_color: c.branding.borderColor,
      kiosk_exit_password: c.kiosk.exitPassword,
      kiosk_inactivity_timeout_seconds: c.kiosk.inactivityTimeoutSeconds,
      kiosk_show_best_scores: c.kiosk.showBestScores,
      game_memory_enabled: c.games.memory.enabled,
      game_memory_pairs: c.games.memory.pairs,
      game_puzzle_enabled: c.games.puzzle.enabled,
      game_reaction_enabled: c.games.reaction.enabled,
      game_simon_enabled: c.games.simon.enabled,
      game_simon_colors: c.games.simon.colors,
      game_simon_speed_ms: c.games.simon.speedMs,
      game_whack_enabled: c.games.whack.enabled,
      game_whack_duration_seconds: c.games.whack.durationSeconds,
      game_speedtap_enabled: c.games.speedtap.enabled,
      game_speedtap_duration_seconds: c.games.speedtap.durationSeconds,
      game_balloonpop_enabled: c.games.balloonpop.enabled,
      game_balloonpop_duration_seconds: c.games.balloonpop.durationSeconds,
      records_enabled: c.records.enabled,
      records_require_rut: c.records.requireRut,
      records_require_name: c.records.requireName,
      records_max_entries_per_game: c.records.maxEntriesPerGame,
    };
  }

  save() {
    this.saving = true;
    this.message = '';
    this.error = '';
    this.api.updateClient(this.clientCode, this.flat).subscribe({
      next: () => {
        this.saving = false;
        this.message = 'Configuración guardada correctamente';
        this.loadConfig();
        setTimeout(() => this.message = '', 4000);
      },
      error: (err) => {
        this.saving = false;
        this.error = 'Error al guardar: ' + (err.error?.detail || err.message);
        setTimeout(() => this.error = '', 5000);
      }
    });
  }

  uploadLogo(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.api.uploadLogo(this.clientCode, file).subscribe({
      next: (res) => {
        this.config!.client.logo = res.logo;
        this.message = 'Logo actualizado';
        setTimeout(() => this.message = '', 3000);
      },
      error: () => { this.error = 'Error al subir logo'; }
    });
  }

  uploadFavicon(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.api.uploadFavicon(this.clientCode, file).subscribe({
      next: (res) => {
        this.config!.client.favicon = res.favicon;
        this.message = 'Favicon actualizado';
        setTimeout(() => this.message = '', 3000);
      },
      error: () => { this.error = 'Error al subir favicon'; }
    });
  }
}
